
namespace RecordShield.Workspace {
    
    @Serenity.Decorators.registerClass()
    export class ActivationLog2Grid extends Serenity.EntityGrid<ActivationLog2Row, any> {
        protected getColumnsKey() { return 'Workspace.ActivationLog2'; }
        protected getDialogType() { return ActivationLog2Dialog; }
        protected getIdProperty() { return ActivationLog2Row.idProperty; }
        protected getLocalTextPrefix() { return ActivationLog2Row.localTextPrefix; }
        protected getService() { return ActivationLog2Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        protected addButtonClick() {

            this.editItem({ ProductSerialId: this.productSerialId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.productSerialId != null;
        }

        private _productSerialId: number;

        get productSerialId() {
            return this._productSerialId;
        }

        set productSerialId(value: number) {
            if (this._productSerialId != value) {
                this._productSerialId = value;
                debugger;
                this.setEquality(ActivationLog2Row.Fields.ProductSerialId, value);
                this.refresh();
            }
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           buttons.splice(0, 1);
            return buttons;
        }

    }
}